export default "__VITE_ASSET__B1Vk9v9U__"